import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import DropDown from '../../baseComponents/dropdown';
import Field from '../../../interfaces/field';
import { FieldAliasRow } from '../types/fieldAliasTypes';
import BaseFieldRow from './BaseFieldRow';


interface CustomerReferenceFieldRowProps {
    row: FieldAliasRow;
    index: number;
    updateRow: (id: string, field: keyof FieldAliasRow, value: any) => void;
    removeRow: (id: string) => void;
    undoDelete: (id: string) => void;
    isDuplicateAliasName: (aliasName: string, currentId: string) => boolean;
    customerDetailFields: Field[];
    customerDetailAttributeFields: Field[];
    handleCustomerDetailTypeSelection: (rowId: string, selectedType: string) => void;
    handleCustomerDetailNumberSelection: (rowId: string, selectedNumber: number) => void;
    handleCustomerDetailAttributeSelection: (rowId: string, selectedAttribute: string) => void;
    getCustomerDetailNumbers: () => string[];
    handleFieldSelection: (rowId: string, selectedFieldId: string) => void;
    secondaryFields: Field[];
}

const CustomerReferenceFieldRow: React.FC<CustomerReferenceFieldRowProps> = (props) => {
    const { 
        row, 
        customerDetailFields,
        customerDetailAttributeFields,
        handleCustomerDetailTypeSelection,
        handleCustomerDetailNumberSelection,
        handleCustomerDetailAttributeSelection,
        getCustomerDetailNumbers
    } = props;

    return (
        <BaseFieldRow {...props} stateType="aliasOnly">

            {/* Customer Reference Configuration */}
            {(row.customer_detail_field_id || row.field_type === 'CUSTOMER_DETAIL_ATTRIBUTE') && ( <>
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle2" mb={2} color="primary">
                        Customer Reference Configuration
                </Typography>

                <Box display="flex" gap={2} mb={2}>
                    <Box width="33%">
                        <DropDown
                            label="Customer Detail Type"
                            items={customerDetailFields.map(field => field.field_name)}
                            selectedValue={row.customerDetailType || ''}
                            onSelection={(value) => handleCustomerDetailTypeSelection(row.id, value)}
                            disabled={!row.is_active}
                            height={40}
                        />
                    </Box>
                        
                    {row.customerDetailType && row.customerDetailType !== 'customer' && (
                        <Box width="33%">
                            <DropDown
                                label={`${row.customerDetailType?.charAt(0).toUpperCase()}${row.customerDetailType?.slice(1)} Number`}
                                items={getCustomerDetailNumbers()}
                                selectedValue={row.customerDetailNumber?.toString() || '1'}
                                onSelection={(value) => handleCustomerDetailNumberSelection(row.id, Number(value))}
                                disabled={!row.is_active}
                                height={40}
                            />
                        </Box>
                    )}
                        
                    {row.customerDetailType && (
                        <Box width="33%">
                            <DropDown
                                label="Customer Detail Attribute"
                                items={customerDetailAttributeFields.map(field => field.field_name)}
                                selectedValue={row.customerDetailAttribute || ''}
                                onSelection={(value) => handleCustomerDetailAttributeSelection(row.id, value)}
                                disabled={!row.is_active}
                                height={40}
                            />
                        </Box>
                    )}
                </Box>

                {row.field_name && (
                    <Box>
                        <Typography variant="body2" color="success.main" sx={{ fontWeight: 'bold' }}>
                                Generated Field Name: {row.field_name}
                        </Typography>
                    </Box>
                )}
            </>
            )}
        </BaseFieldRow>
    );
};

export default CustomerReferenceFieldRow;
